export default __webpack_public_path__ + "static/media/4-tablet.57dd1238.jpg";